import { useIntl } from '@/intl'
import { useState } from 'react'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    headerTitle: translate({ id: 'sms4.settings.trackingPage.title' }),
    headerDescription: translate({ id: 'sms4.settings.trackingPage.description' }),
    companyInformation: translate({
      id: 'sms4.settings.trackingPage.fields.companyInformation.label',
    }),
    companyName: translate({ id: 'sms4.settings.trackingPage.fields.companyName.label' }),
    companySlogan: translate({ id: 'sms4.settings.trackingPage.fields.companySlogan.label' }),
    companyPhone: translate({
      id: 'sms4.settings.trackingPage.fields.companyPhone.label',
    }),
    showContactPhone: translate({
      id: 'sms4.settings.trackingPage.fields.visibleOnTrackingPage.label',
    }),
    showContactPhoneonForm: translate({
      id: 'sms4.settings.trackingPage.fields.showOnTrackingPage.label',
    }),
    companyEmail: translate({ id: 'sms4.settings.trackingPage.fields.companyEmail.label' }),
    showContactEmail: translate({
      id: 'sms4.settings.trackingPage.fields.visibleOnTrackingPage.label',
    }),
    showContactEmailonForm: translate({
      id: 'sms4.settings.trackingPage.fields.showOnTrackingPage.label',
    }),
    useCompanyEmailAsReplyTo: translate({
      id: 'sms4.settings.trackingPage.fields.useCompanyEmailAsReplyTo.label',
    }),
    usedCompanyEmailAsReplyTo: translate({
      id: 'sms4.settings.trackingPage.fields.useCompanyEmailAsReplyTo.label',
    }),
    showEtaRange: translate({ id: 'sms4.settings.trackingPage.fields.showEtaRange.label' }),
    showEtaRangeHelperText: translate({
      id: 'sms4.settings.trackingPage.fields.showEtaRange.helperText',
    }),
    podsTitle: translate({ id: 'sms4.settings.trackingPage.fields.pods.title' }),
    picture: translate({ id: 'sms4.settings.trackingPage.fields.pods.showPicturePod.label' }),
    signature: translate({ id: 'sms4.settings.trackingPage.fields.pods.showSignaturePod.label' }),
    voiceMemo: translate({ id: 'sms4.settings.trackingPage.fields.pods.showVoiceMemoPod.label' }),
    driverNote: translate({ id: 'sms4.settings.trackingPage.fields.pods.showDriverNotePod.label' }),
    podsHelperText: translate({ id: 'sms4.settings.trackingPage.fields.pods.helperText' }),
    waringCardTitle: translate({ id: 'sms4.settings.trackingPage.warningCard.title' }),
    waringCardDescription: translate({ id: 'sms4.settings.trackingPage.warningCard.description' }),
    waringCardLinkText: translate({ id: 'sms4.settings.trackingPage.warningCard.link' }),
    save: translate({ id: 'sms4.settings.trackingPage.footer.action.save' }),
    preview: translate({ id: 'sms4.settings.trackingPage.footer.action.preview' }),
    cancel: translate({ id: 'sms4.settings.trackingPage.footer.action.cancel' }),
    onOff: (value: boolean) =>
      translate({ id: value ? 'sms4.settings.trackingPage.on' : 'sms4.settings.trackingPage.off' }),
    edit: translate({ id: 'sms4.settings.trackingPage.edit' }),

    validations: {
      companyNameMaxLength: (maxCharacters: number) =>
        translate({
          id: 'sms4.settings.trackingPage.fields.companyName.error.maxLength',
          values: { maxCharacters },
        }),
      companySloganMaxLength: (maxCharacters: number) =>
        translate({
          id: 'sms4.settings.trackingPage.fields.companySlogan.error.maxLength',
          values: { maxCharacters },
        }),
      companyPhoneInvalidFormat: translate({
        id: 'sms4.settings.trackingPage.fields.companyPhone.error.invalidFormat',
      }),
      companyEmailInvalidFormat: translate({
        id: 'sms4.settings.trackingPage.fields.companyEmail.error.invalidFormat',
      }),
    },
  }))

  return api
}

export type Texts = ReturnType<typeof useTexts>
